import { render, staticRenderFns } from "./AgentParameterSetting.vue?vue&type=template&id=3587be45"
import script from "./AgentParameterSetting.vue?vue&type=script&lang=js"
export * from "./AgentParameterSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports